import {
  DEFAULT_CONTROLS,
  RARITY_BACKDROP_VARIANTS,
  RIP_BUTTON_OPTIONAL_VARIANTS,
  type AnimationVariant,
  type ControlsConfig,
  type PreviewTemplate,
} from '@game-platform/pack-animation';
import { Checkbox } from '../../components/ui/Checkbox';

interface Props {
  variant: AnimationVariant;
  /** Sleek keeps its page dark after the pull, so it has no rarity word. */
  template: PreviewTemplate;
  /** Absent means the default: the button shows. */
  controls: ControlsConfig | undefined;
  onChange: (controls: Partial<ControlsConfig>) => void;
}

/** The host's own layers around the scene. Only for mechanics that open
 *  without a button — the carousel's button shuffles the ring, so it always
 *  stays. */
export function ControlsPanel({ variant, template, controls, onChange }: Props) {
  if (!RIP_BUTTON_OPTIONAL_VARIANTS.includes(variant)) return null;
  const current = controls ?? DEFAULT_CONTROLS;
  const hasRarityBackdrop = RARITY_BACKDROP_VARIANTS.includes(variant) && template !== 'sleek';
  return (
    <section>
      <h2 className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-[var(--co-muted)]">
        Controls
      </h2>
      <Checkbox
        aria-label="Rip button"
        label="Show the Rip button under the pack"
        checked={current.ripButton}
        onChange={(ripButton) => onChange({ ripButton })}
      />
      <p className="mt-1 text-[11px] leading-[15px] text-[var(--co-muted)]">
        Off: the pack opens by gesture only and sits centred on the screen.
      </p>
      {hasRarityBackdrop && (
        <>
          <div className="mt-3">
            <Checkbox
              aria-label="Rarity backdrop"
              label="Show the rarity name behind the card"
              checked={current.rarityBackdrop === true}
              onChange={(rarityBackdrop) => onChange({ rarityBackdrop })}
            />
          </div>
          <p className="mt-1 text-[11px] leading-[15px] text-[var(--co-muted)]">
            On: Rare and above get their name as a giant outline word behind the landed card, as in the
            Slot Lane.
          </p>
        </>
      )}
    </section>
  );
}
